import { SectionHeadingContainer } from '@/components/SectionHeadingContainer';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const concerns = [
  { id: 1, text: 'このまま同じ毎日を続けていいのか、ふと不安になる' },
  { id: 2, text: '頑張っているのに、収入も環境も変わらない' },
  { id: 3, text: 'もっと成長したいのに、周りに刺激がない' },
  { id: 4, text: 'やりたいことはあるけど、踏み出せていない' },
  { id: 5, text: '自分の可能性を、このまま終わらせたくない'},
];

const itemDelays = ['delay-2', 'delay-2', 'delay-3', 'delay-4', 'delay-5'] as const;

export default function ConcernsSection() {
  const ref = useScrollAnimation();

  return (
    <section
      ref={ref}
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: '#F5F2EB', paddingTop: '65px', paddingBottom: '20px' }}
      aria-label="お悩みセクション"
    >
      <div
        className="pointer-events-none absolute left-0 top-0 bottom-0 w-px opacity-40"
        style={{
          background:
            'linear-gradient(180deg, transparent 0%, rgba(168,205,217,0.5) 20%, rgba(168,205,217,0.5) 80%, transparent 100%)',
        }}
        aria-hidden={true}
      />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-8 lg:px-16">
        <div className="fade-in-up mb-6">
          <span
            className="section-label-en font-montserrat font-light uppercase"
            style={{ color: '#A8CDD9' }}
          >
            YOUR CONCERNS
          </span>
        </div>

        <SectionHeadingContainer>
          <h2
            className="section-heading section-heading--concerns fade-in-up delay-1 mb-14 text-center lg:mb-16"
            style={{
              color: '#1A1A1A',
            }}
          >
            こんなお悩み、ありませんか？
          </h2>
        </SectionHeadingContainer>

        {/* グリッドは使わず、狭い1カラムの縦リストのみ（本文は cqi で列幅に追従） */}
        <div className="concerns-body-container mx-auto max-w-2xl">
          <ul className="list-none pl-0">
            {concerns.map((concern, i) => (
              <li
                key={concern.id}
                className={`fade-in-up flex gap-2 border-b border-solid py-5 first:pt-0 last:border-b-0 sm:gap-6 sm:py-10 ${itemDelays[i] ?? 'delay-3'}`}
                style={{ borderColor: 'rgba(168, 205, 217, 0.28)' }}
              >
                <span
                  className="mt-[0.65em] h-0.5 w-2 shrink-0 rounded-sm"
                  style={{ backgroundColor: 'rgba(184, 155, 74, 0.55)' }}
                  aria-hidden={true}
                />
                <p
                  className="concerns-list-copy min-w-0 flex-1 font-light"
                  style={{
                    color: '#3A3A3A',
                    fontFamily: "'Noto Sans JP', sans-serif",
                    fontWeight: 300,
                  }}
                >
                  {concern.text}
                </p>
              </li>
            ))}
          </ul>
        </div>

        <aside
          className="fade-in-up delay-5 mx-auto mt-16 max-w-2xl border-l-[3px] pl-7 sm:mt-20"
          style={{ borderColor: '#B89B4A' }}
        >
        </aside>
      </div>
    </section>
  );
}
